import type { DanceSeoHead } from "../danceSeoTypes.js";

// de translation of shared/danceSeoHeads/en.ts; numbers and claims must stay in sync with the English source.
const head: DanceSeoHead = {
  director: {
    title: "KI-Tanzvideo-Generator aus Musik – kostenlos starten",
    description:
      "Mach aus jedem Song ein komplettes KI-Tanzvideo. Solmi plant die Choreografie für jeden Abschnitt und rendert Tanz- und Lip-Sync-Szenen. Kostenlos starten.",
    h1: "KI-Tanzvideo-Generator – mach aus jedem Song ein Tanzvideo",
  },
  photo: {
    title: "Foto tanzen lassen – KI-Tanzgenerator aus Foto | Solmi",
    description:
      "Foto tanzen lassen mit KI: Ganzkörperfoto hochladen, Move wählen oder eigenen Tanzclip nutzen, Song dazu. Solmi bringt den Tanz auf den Beat. Kostenlos starten.",
    h1: "Foto tanzen lassen – KI-Tanzgenerator aus Foto",
  },
  inbound:
    "Soll dein Performer tanzen? Der [KI-Tanzvideo-Generator](/ai-dance-video-generator) plant die Choreografie für jeden Abschnitt deines Songs und rendert ein komplettes Tanzvideo.",
};

export default head;
